import { render, staticRenderFns } from "./AnswersReportExampleDetailTop.vue?vue&type=template&id=25cb6ec7&"
import script from "./AnswersReportExampleDetailTop.vue?vue&type=script&lang=js&"
export * from "./AnswersReportExampleDetailTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports